<template>
  <estimates-list></estimates-list>
</template>

<script>
import EstimatesList from '../components/estimates/EstimatesList';

export default {

  components: {
    EstimatesList,
  },

  created() {
    this.$store.dispatch('estimates/loadList');
    document.title = 'Сметы';
  },
}
</script>